/** Convierte enlaces guardados por el API (absolutos con #/) en ruta para React Router. */
export function normalizeNotificationLink(
  link: string | undefined | null
): string {
  if (!link || typeof link !== 'string') {
    return '';
  }
  const trimmed = link.trim();
  if (trimmed.startsWith('/')) {
    return trimmed;
  }
  try {
    const u = new URL(trimmed);
    if (u.hash && u.hash.startsWith('#/')) {
      return u.hash.slice(1);
    }
    return `${u.pathname}${u.search}`;
  } catch {
    const idx = trimmed.indexOf('#/');
    if (idx !== -1) {
      const path = trimmed.slice(idx + 1);
      return path.startsWith('/') ? path : `/${path}`;
    }
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }
}
